import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d64e807"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-transfer-customize-list ant-transfer-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-transfer-list-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "已选择")
], -1))
const _hoisted_3 = { class: "ant-transfer-list-body" }
const _hoisted_4 = { class: "ant-transfer-list-content" }
const _hoisted_5 = { class: "tree-node-item" }
const _hoisted_6 = { class: "tree-node-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ResultModal = _resolveComponent("ResultModal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event)),
    title: "生成账单",
    width: "750px",
    onCancel: _ctx.handleCancel
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取 消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        loading: _ctx.loading,
        onClick: _ctx.handleOk
      }, {
        default: _withCtx(() => [
          _createTextVNode("生成账单")
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.formState,
        rules: _ctx.rules,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "选择时间",
            name: "timeRange"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_range_picker, {
                value: _ctx.formState.timeRange,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.timeRange) = $event)),
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                placeholder: ['起始时间', '结束时间'],
                style: {"width":"100%"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "账单类型",
            name: "billDimension"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.formState.billDimension,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.billDimension) = $event)),
                onChange: _ctx.changeBillDimension
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: "ENTERPRISE" }, {
                    default: _withCtx(() => [
                      _createTextVNode("按公司生成对账单")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: "DEPARTMENT" }, {
                    default: _withCtx(() => [
                      _createTextVNode("按部门生成对账单")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: _ctx.formState.billDimension === 'ENTERPRISE'?'选择公司':'选择部门',
            name: "enterpriseOrDept"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (_ctx.formState.billDimension === 'ENTERPRISE')
                      ? (_openBlock(), _createBlock(_component_a_tree, {
                          key: 0,
                          checkedKeys: _ctx.checkedEnterpriseIds,
                          "onUpdate:checkedKeys": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkedEnterpriseIds) = $event)),
                          "tree-data": _ctx.enterpriseTree,
                          checkable: "",
                          "check-strictly": "true",
                          selectable: false,
                          "default-expand-all": true,
                          "auto-expand-parent": true
                        }, {
                          title: _withCtx((nodeData) => [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("span", null, _toDisplayString(nodeData.title), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["checkedKeys", "tree-data"]))
                      : (_openBlock(), _createBlock(_component_a_tree, {
                          key: 1,
                          checkedKeys: _ctx.checkedDepartmentIds,
                          "onUpdate:checkedKeys": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkedDepartmentIds) = $event)),
                          "tree-data": _ctx.departmentTree,
                          checkable: "",
                          selectable: false,
                          "default-expand-all": "",
                          "auto-expand-parent": true
                        }, {
                          title: _withCtx((nodeData) => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("span", null, _toDisplayString(nodeData.title), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["checkedKeys", "tree-data"]))
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model", "rules", "label-col", "wrapper-col"]),
      (_ctx.isShowResult)
        ? (_openBlock(), _createBlock(_component_ResultModal, {
            key: 0,
            "result-info": _ctx.resultInfo,
            onClose: _ctx.closeResultModal
          }, null, 8, ["result-info", "onClose"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}